import React, { useEffect, useState } from 'react';
import './index.scss';
//import html2canvas from 'html2canvas';
import html2canvas from '../../../utils/html2canvas';
import QRCode from 'qrcode.react';
//import { Loading } from '../../../components/loading';
import { ShareLoading } from '../../../components/copyright/shareLoading';
import { lockBody, unLockBody, isVideoUrl } from '../../../utils/common';
export const DetailShare = props => {
	if (props.data.list.length >= 6) {
		let arr = [];
		for (let i=0;i<6;i++) {
			arr.push(props.data.list[i]);
		}
		props.data.list = arr;
	}
	let imgageLoadedCount = 0;
	function List(props) {
		return props.list.map(item => {
			let imageSrc = isVideoUrl(item.key) ? props.thumbKey || item.thumbKey : item.key;
			return (
				<li key={item.key}>
					<img src={imageSrc} alt="" onLoad={handleOnload} />
					<p className="image-des">{item.description}</p>
				</li>
			);
		});
	}

	let { fromAvatar, fromName, photographerAvatar, photographerName, topicName, contentId, sectionId, title, list, thumbKey } = props.data;
	// contentId 大图页分享淡妆图片，sectionId 上传历史分享一组图片

	function geneQrCode() {
		// let topicId = props.data.topicId || props.data.list[0].topicId;
		let param = '?';
		if (contentId) {
			// 大图页分享单张图片
			param += `contentId=${contentId}`;
		}
		if (sectionId) {
			// 上传历史分享一组图片
			param += `sectionId=${sectionId}`;
		}
		let url = window.location.origin + '/vpmobile/copyright/sharedPage/' + param;
		console.log('shared url', url);
		// debugger;
		return url;
	}
	function convertCanvasToImage(canvas) {
		var image = new Image();
		image.src = canvas.toDataURL('image/png');
		return image;
	}

	function handleClose() {
		unLockBody();
		props.onClose();
	}

	// 要生成的图片越长，分辨率越低
	function calcScale(height) {
		if (height > 1000) {
			let min = 0.4 * window.devicePixelRatio;
			let scale = window.devicePixelRatio - (height - 1000) / 2500;
			if (scale < min) {
				return min;
			}
			return scale;
		}
		return window.devicePixelRatio;
	}

	function handleOnload() {
		imgageLoadedCount += 1;
		if (imgageLoadedCount === list.length) {
			setTimeout(() => {
				let detailShareNode = document.querySelector('.detail-share');
				let wrapper = document.querySelector('.detail-share-wrapper');
				let scrollTip = document.querySelector('.scroll-tip');
				let scale = calcScale(wrapper.offsetHeight);
				if (wrapper.offsetHeight < window.innerHeight - 40) {
					scrollTip.style.display = 'none';
				}
				try{
					html2canvas(wrapper, { useCORS: true, scale }).then(canvas => {
						if (detailShareNode.children.length === 5) {
							let image = convertCanvasToImage(canvas);
							image.className = 'share-image min-height';
							document.addEventListener(
								'scroll',
								() => {
									scrollTip.style.display = 'none';
								},
								{ once: true }
							);
							detailShareNode.appendChild(image);
							wrapper.style.display = 'none';
							detailShareNode.style.height = '';
							detailShareNode.style.overflow = '';
							detailShareNode.style.position = '';
							setTimeout(() => {
								document.querySelector('.loading-cover').style.display = 'none';
//								lockBody();
								image.classList.remove('min-height');
							}, 50);
						}
					}).catch(err => {
						console.error(err);
					});
					
				}catch(e){
					console.error(e);
				}
			}, 500); // 等待logo等静态资源
		}
	}

	return (
		<div className="detail-share" style={{position: 'fixed', height: '100vh', overflow: 'hidden'}} onTouchStart={e=>e.stopPropagation()} onTouchMove={e=>e.stopPropagation()} onTouchEnd={e=>e.stopPropagation()}>
			{/* <div id="image-container"></div> */}
			<div className="longpress-tip">
				<i className="iconfont">&#xe656;</i>
				<span>长按即可保存长图</span>
			</div>
			<div className="close-button" onClick={handleClose}>
				<i className="iconfont">&#xe652;</i>
			</div>
			<div className="detail-share-wrapper">
				<header className="detail-share-header">
					<img alt="" className="logo" src="https://gallerytemplate.vphotos.cn/copyright/logo%402x.png" />
					<div className="from-info">
						{fromAvatar ? <img className="avatar" src={fromAvatar} alt="" /> : ''}
						<p className="des">
							{fromName}
							{props.from === 'ucenter' ? '在投图版权平台中上传了一组内容，快来给我点赞吧~' : '在投图版权平台中看到一组内容感觉很赞，好东西不独享，一起欣赏下吧~'}
						</p>
					</div>
					<div className="photographer-info">
						{photographerAvatar ? <img className="avatar" src={photographerAvatar} alt="" /> : ''}
						{photographerName ? <p className="des">照片由{photographerName}提供</p> : ''}
						{topicName ? (
							<p className="topic">
								<span className="iconfont topic"></span>
								{topicName}
							</p>
						) : (
							''
						)}
					</div>
				</header>
				<div className="detail-share-content">
					{title ? (
						<h2 className="title">
							<span className="context">{title}</span>
						</h2>
					) : (
						''
					)}
					<ul className="image-list">
						<List list={list} thumbKey={thumbKey} />
					</ul>
				</div>
				<footer className="detail-share-footer">
					<QRCode value={geneQrCode()} size={80} fgColor="#777" bgColor="#f5f3f3" />
					<p className="tip-more">扫码查看更多作品</p>
					<img className="slogan" src="https://gallerytemplate.vphotos.cn/copyright/slogan%402x.png" alt="" />
					<br />
					<img className="logo" src="https://gallerytemplate.vphotos.cn/copyright/logo%402x.png" alt="" />
				</footer>
			</div>
			<div className="loading-cover">
				<ShareLoading />
			</div>
			<span className="scroll-tip">
				<i className="iconfont">&#xe66c;</i>
				<div>滑动查看全部长图</div>
			</span>
		</div>
	);
};
